export default __webpack_public_path__ + "static/relay_splash-ca6069b90102ec28a1be998101defe6a.png";